import { Pipe, PipeTransform, inject } from '@angular/core';
import { LanguageService } from './language.service';

/**
 * The project-owned translation pipe.
 *
 * ```html
 * {{ 'GENERAL.SAVE' | t }}
 * {{ 'GRID.SELECTED' | t: { count: selected.length } }}
 * ```
 *
 * No template in this application imports `| transloco`. They all go through here, so swapping
 * the engine never touches a single `.html` file.
 *
 * **`pure: false` is deliberate.** A pure pipe only re-runs when its INPUT changes, and the input
 * here is a constant string literal — it never changes, so a pure pipe would render the boot
 * language forever and never react to a switch. Impurity makes it re-run on every change
 * detection cycle; the `currentLang()` signal read inside `resolve()` is what makes that cycle
 * happen in the first place. Both are required. Neither alone is sufficient.
 *
 * `resolve()` (not `t()`) is used because a template literal is a `string` to the compiler, and
 * because passthrough is what lets an un-migrated Spanish literal render unchanged.
 */
@Pipe({
  name: 't',
  standalone: true,
  pure: false,
})
export class TranslatePipe implements PipeTransform {
  private readonly i18n = inject(LanguageService);

  transform(key: string, params?: Record<string, unknown>): string {
    return this.i18n.resolve(key, params);
  }
}
